import styled from "styled-components";

export const IdListPageStyle=styled.div`

.edit-div{
  height: 250px;
  overflow-y: auto;
  margin-top: 10px;
  margin-bottom: 10px;
}

.input-field{
  height:3vh;
  margin-bottom:5px;
  width: 80%;
  font-size:14px;
  font-family: "Inter var", sans-serif;
  :focus{
    border: 1px solid gray;
    box-shadow: 0 0 5px #f7951d;
  }
}
.input-field2{
  height:3vh;
  margin-bottom:5px;
  width:80%;
  font-size:14px;
  font-family: "Inter var", sans-serif;
  :focus{
    border-color:white;
    box-shadow: 0 0 5px #f7951d;
  }
}

.remove-icon{
    font-size: 20px;
    color:#dd3e3e;
    margin-right:10px;
}

.edit-icon{
  font-size: 20px;
  color:#4cdb4c;
}

.input-div{
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}


.action-div{
  padding: 4px 6px;
  border-radius: 7px;
  background-color:#f28809;
  color:white;
}
.action-div2{
  padding: 4px 6px;
  border-radius: 7px;
  background-color:red;
  color:white;
}

.text-error{
  font-family: "Inter var", sans-serif;
  color:red;
  font-size:14px;
  margin-left:2px;
  margin-bottom:0;
}

.spinner-div{
  margin-right:15px;
}

`